import { render } from "./AddNewInvoiceFrequency.vue?vue&type=template&id=c6d2cb6c"
import script from "./AddNewInvoiceFrequency.vue?vue&type=script&lang=js"
export * from "./AddNewInvoiceFrequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__